import { render } from "./ApplicationLogo.vue?vue&type=template&id=77f0ab31"
const script = {}
script.render = render

export default script